var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 36.0005C28.8346 36.0005 35.9981 28.837 35.9981 20.0005C35.9981 11.1639 28.8346 4.00049 19.998 4.00049C11.1615 4.00049 3.99805 11.1639 3.99805 20.0005C3.99805 28.837 11.1615 36.0005 19.998 36.0005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1643 13.3337C29.9309 13.3337 30.6809 13.2503 31.3976 13.1337C29.0643 9.26699 24.8309 6.66699 19.9975 6.66699C19.2308 6.66699 18.4808 6.75033 17.7642 6.86699C20.0976 10.7337 24.3309 13.3337 29.1643 13.3337Z",
    fill: "#00DA93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4621 8.38379C10.6121 10.0005 8.41206 12.6338 7.36206 15.7838C10.2121 14.1671 12.4121 11.5338 13.4621 8.38379Z",
    fill: "#00DA93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.3335C10.8 3.3335 3.33331 10.8002 3.33331 20.0002C3.33331 29.2002 10.8 36.6668 20 36.6668C29.2 36.6668 36.6666 29.2002 36.6666 20.0002C36.6666 10.8002 29.2 3.3335 20 3.3335ZM20 6.66683C24.8333 6.66683 29.0666 9.26683 31.4 13.1335C30.6833 13.2502 29.9333 13.3335 29.1666 13.3335C24.3333 13.3335 20.1 10.7335 17.7666 6.86683C18.4833 6.75016 19.2333 6.66683 20 6.66683ZM13.4666 8.3835C12.4166 11.5335 10.2166 14.1668 7.36665 15.7835C8.41665 12.6335 10.6166 10.0002 13.4666 8.3835ZM20 33.3335C12.65 33.3335 6.66665 27.3502 6.66665 20.0002C6.66665 19.9168 6.68331 19.8335 6.68331 19.7502C11.0166 18.1168 14.4833 14.7668 16.25 10.5002C19.3 14.2668 23.95 16.6668 29.1666 16.6668C30.4166 16.6668 31.6166 16.5168 32.7833 16.2668C33.1333 17.4502 33.3333 18.7002 33.3333 20.0002C33.3333 27.3502 27.35 33.3335 20 33.3335Z",
    fill: "#28241C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9955 23.7501C16.1461 23.7501 17.0788 22.8174 17.0788 21.6667C17.0788 20.5163 16.1461 19.5835 14.9955 19.5835C13.8449 19.5835 12.9122 20.5163 12.9122 21.6667C12.9122 22.8174 13.8449 23.7501 14.9955 23.7501Z",
    fill: "#28241C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.995 23.7501C26.1456 23.7501 27.0783 22.8174 27.0783 21.6667C27.0783 20.5163 26.1456 19.5835 24.995 19.5835C23.8443 19.5835 22.9116 20.5163 22.9116 21.6667C22.9116 22.8174 23.8443 23.7501 24.995 23.7501Z",
    fill: "#28241C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ecb83ad7a232d4e7be35cb3f568a5418.svg";
export { ForwardRef as ReactComponent };